import { render, staticRenderFns } from "./GireseExpediente.vue?vue&type=template&id=7ce4cadc&scoped=true"
import script from "./GireseExpediente.vue?vue&type=script&lang=js"
export * from "./GireseExpediente.vue?vue&type=script&lang=js"
import style0 from "./GireseExpediente.vue?vue&type=style&index=0&id=7ce4cadc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce4cadc",
  null
  
)

export default component.exports